import React, { createContext, useContext, useMemo } from "react";

import {
  getWhiteLabelConfig,
  shouldHideMenuItem,
  shouldHideDashboardComponent,
} from "config/whitelabel.config";

const WhiteLabelContext = createContext(null);

export const WhiteLabelProvider = ({ children }) => {
  const config = useMemo(() => getWhiteLabelConfig(), []);

  const value = useMemo(
    () => ({
      ...config,
      shouldHideMenuItem: (menuTitle, parentTitle = null) =>
        shouldHideMenuItem(config, menuTitle, parentTitle),
      shouldHideDashboardComponent: (componentName) =>
        shouldHideDashboardComponent(config, componentName),
    }),
    [config],
  );

  return (
    <WhiteLabelContext.Provider value={value}>
      {children}
    </WhiteLabelContext.Provider>
  );
};

export const useWhiteLabel = () => {
  const context = useContext(WhiteLabelContext);
  if (!context) {
    throw new Error("useWhiteLabel must be used within a WhiteLabelProvider");
  }
  return context;
};

export default WhiteLabelContext;
